// client/src/policies/passwordPolicy.js
// ⚠️  CE FICHIER EST DUPLIQUÉ INTENTIONNELLEMENT dans functions/policies/passwordPolicy.js
// Les deux doivent rester IDENTIQUES. Toute modification ici doit être reportée dans l'autre.
const REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/;

const POLICY = {
  minLength: 8,
  requireUpper: true,
  requireLower: true,
  requireDigit: true,
  requireSpecial: true,
  regex: REGEX.source,
  message: 'Le mot de passe doit contenir au moins 8 caractères, dont 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.'
};

function validatePassword(pw) {
  return REGEX.test(pw || '');
}

module.exports = { POLICY, REGEX, validatePassword };
